import React from 'react';
import ShareInvite from '../../components/ShareInvite';

/**
 * Share a league's join link. A league is one kind of invite; `ShareInvite` carries the
 * share sheet, the WhatsApp button and the wording (backlog item 89).
 *
 * `joinOpen` is the server's answer to whether the code still gets somebody straight in -
 * before the first game it does, after it the manager has to say yes.
 */
function ShareLeague({ league, className }) {
  return (
    <ShareInvite
      kind="league"
      name={league.name}
      code={league.leagueCode}
      straightIn={Boolean(league.joinOpen)}
      className={className}
    />
  );
}

export default ShareLeague;
